<template>
  <v-container class="hkiarace-banner-frame p-0" fluid v-bind="$attrs">
    <v-parallax
        v-if="!noParallax"
        class="hkiarace-banner-frame-banner m-0"
        dark
        :height="isAlwaysLarge ? 400 : (pageWidth > 1200 ? 400 : 200)"
        :src="src || defaultImgSrc"
        :style="bannerStyle"
    >
      <div class="hkiarace-banner-frame-label title-font">
        <span :class="isSnapContent?'transform-label':''">{{ label }}</span>
      </div>
    </v-parallax>
    <div class="hkiarace-banner-frame-banner"
         v-if="noParallax"
         :style="[internalBannerStyle, bannerStyle]">
      <div class="hkiarace-banner-frame-label title-font">
        <span :class="isSnapContent?'transform-label':''">{{ label }}</span>
      </div>
    </div>
    <!--<div class="hkiarace-banner-frame-label-word-container">-->
    <!--<div class="hkiarace-banner-frame-label-word hkiarace-banner-sticky" style="top: 140px">-->
    <!--<span :class="isSnapContent?'transform-label':''">{{label}}</span>-->
    <!--</div>-->
    <!--</div>-->
    <v-row :class="['hkiarace-banner-frame-content m-0', {'transform-content': isSnapContent}]" v-if="!isBannerOnly">
      <v-col :class="{'hkiarace-banner-frame-content-wrapper': isSnapContent}">
        <slot></slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";

export default {
  name: 'HkiaraceBannerFrame',
  props: {
    src: String,
    label: String,
    transformContent: String,
    isBannerOnly: Boolean,
    isAlwaysLarge: Boolean,
    isSnapContent: Boolean,
    isSticky: Boolean,
    bannerStyle: String,
    noParallax: Boolean,
  },
  setup(props, {root}) {
    const pageWidth = ref(9999);
    const defaultImgSrc = ref(require('../assets/acc.jpg'));
    const internalBannerStyle = computed(() => {
      return {
        height: props.isAlwaysLarge ? '400px' : (pageWidth.value > 1200 ? '400px' : '200px'),
        backgroundImage: `url(${props.src || defaultImgSrc.value})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }
    })

    onMounted(() => {
      pageWidth.value = window.innerWidth;
      root.$nextTick(() => {
        window.addEventListener('resize', () => {
          pageWidth.value = window.innerWidth;
        });
      })
    });

    return {
      pageWidth,
      defaultImgSrc,
      internalBannerStyle,
    }
  },
}
</script>

<style lang="less">
.hkiarace-banner-frame {
  padding: 30px;

  .hkiarace-banner-frame-label {
    /*position: absolute;*/
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

    color: white;
    font-size: 3rem;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.2);
    letter-spacing: 1px;
    text-transform: uppercase;
    font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;

    background-color: rgba(11, 11, 11, 0.2);

    @media only screen and (max-width: 1200px) {
      font-size: 1.5rem;
    }
  }

  .hkiarace-banner-frame-label-word-container {
    z-index: 1;
    background-color: black;
    pointer-events: none;
    position: absolute;
    width: 100%;
    /*height: 100%;*/
    margin-top: -400px;
    /*top: -70px;*/
    /*padding-top: 140px;*/
    /*display: flex;*/
    justify-content: center;
    /*align-items: center;*/
  }

  .hkiarace-banner-frame-label-word {
    color: white;
    font-size: 3rem;
    text-shadow: 2px 2px rgba(0, 0, 0, 0.2);
    letter-spacing: 1px;
    text-transform: uppercase;
    font-family: 'Montserrat', "PingFang TC", "Heiti TC", "微軟正黑體", "Microsoft JhengHei", "sans-serif" !important;

    @media only screen and (max-width: 1200px) {
      font-size: 1.5rem;
    }
  }

  .hkiarace-banner-frame-content {
    background-color: #efefef;
    padding: 2rem 0 5rem;

    @media only screen and (max-width: 1200px) {
      padding: 0;
      padding-top: 8px;
    }

    &.transform-content {
      padding-bottom: 0 !important;

      .hkiarace-banner-frame-content-wrapper {
        /*transform: translateY(-10rem);*/
      }
    }
  }
}

.v-parallax__content {
  padding: 0px !important;
}

.hkiarace-banner-sticky {
  position: -webkit-sticky !important;
  position: sticky !important;
}

@media only screen and (min-width: 1200px) {
  .hkiarace-banner-frame-content {
    padding-left: 10rem !important;
    padding-right: 10rem !important;
  }

  .transform-label {
    transform: translateY(-60px);
  }

  .hkiarace-banner-frame-content-wrapper {
    transform: translateY(-200px) !important;
  }
}
</style>
